import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BoltDischargeFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M18.9531 19.2656L21.0869 17.1084L21.2637 16.9297L21.4414 17.1074L22.0664 17.7334L22.2432 17.9102L18.3721 21.7812L18.1953 21.959L18.0186 21.7812L14.3232 18.0869L14.1465 17.9102L15.127 16.9297L15.3037 17.1084L17.4365 19.2656V13.75H18.9531V19.2656ZM10.0596 10.7998H16.5596L7.36035 21.2803H6.13965L8.01953 13.1406H1.5L10.7197 2.66016H11.9404L10.0596 10.7998Z" />
    </SvgIcon>
  );
});
